import i18nFactory from '@yandex-int/i18n';
import classNames from 'classnames';
import { Modal } from 'lego-on-react';
import * as React from 'react';

import { Bem } from '../../service/Bem/Bem';
import { keyDownManager } from '../../service/KeyDownManager/KeyDownManager';
import { KeyCode } from '../../typings/common';
import { ButtonDecorator } from '../ButtonDecorator/ButtonDecorator';

import './Confirm.css';
import * as keyset from './Confirm.i18n';

const i18n = i18nFactory(keyset);

export interface ConfirmProps {
    message: string;
    successText?: string;
    declineText?: string;
    onSuccessClick: () => void;
    onDeclineClick: () => void;
    children?: React.ReactNode;
}

const BLOCK = 'confirm';

export class Confirm extends React.Component<ConfirmProps> {
    private keyDownManagerId: string;

    render() {
        const { onSuccessClick, onDeclineClick, successText, declineText, children, message } = this.props;

        return (
            <Modal theme="normal" view="classic" visible={true} cls={Bem.cls(BLOCK)}>
                <div className={Bem.cls(BLOCK, 'content')}>
                    <div className={Bem.cls(BLOCK, 'header')}>
                        <h3 className={Bem.cls(BLOCK, 'title')}>{message}</h3>
                    </div>

                    {children ? <div className={Bem.cls(BLOCK, 'body')}>{children}</div> : null}
                    <div className={Bem.cls(BLOCK, 'footer')}>
                        <ButtonDecorator
                            cls={classNames(Bem.cls(BLOCK, 'footer-btn'), Bem.cls(BLOCK, 'accept'))}
                            theme="action"
                            view="default"
                            tone="default"
                            size="n"
                            focused={true}
                            onClick={onSuccessClick}
                        >
                            {successText || i18n('yes')}
                        </ButtonDecorator>
                        <ButtonDecorator
                            cls={classNames(Bem.cls(BLOCK, 'footer-btn'), Bem.cls(BLOCK, 'reject'))}
                            theme="pseudo"
                            view="default"
                            tone="default"
                            size="n"
                            onClick={onDeclineClick}
                        >
                            {declineText || i18n('no')}
                        </ButtonDecorator>
                    </div>
                </div>
            </Modal>
        );
    }

    componentDidMount() {
        const { onSuccessClick, onDeclineClick } = this.props;
        // cyn@todo в хеш
        this.keyDownManagerId = keyDownManager.on([[KeyCode.RETURN, onSuccessClick], [KeyCode.ESC, onDeclineClick]]);
    }

    componentWillUnmount() {
        keyDownManager.off(this.keyDownManagerId);
    }
}
